import * as React from "react";
import { useTranslation } from "react-i18next";

import { useSetDemoSessionHidden } from "@/api/demoSession";
import { useOptionalToast } from "@/hooks/useToast";

/** "Hide demo" from the list or the demo's header: stores the
 *  preference, then says where to show it again; a failure says so too,
 *  so a click that didn't stick never looks like it did. */
export function useHideDemoSession(): {
  hide: (onHidden?: () => void) => void;
  isPending: boolean;
} {
  const { t } = useTranslation();
  const toast = useOptionalToast();
  const setHidden = useSetDemoSessionHidden();
  const { mutate } = setHidden;
  const hide = React.useCallback(
    (onHidden?: () => void) =>
      mutate(true, {
        onSuccess: () => {
          toast?.(t("demo_session.hidden_toast"), "success");
          onHidden?.();
        },
        onError: () => toast?.(t("demo_session.hide_failed"), "error"),
      }),
    [mutate, t, toast],
  );
  return { hide, isPending: setHidden.isPending };
}
